import { t } from 'i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { manufacturerService } from 'parts/services';

interface IProps {
  name: string;
}

export const ManufacturerField = ({ name = 'manufacturer' }: IProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      name={name}
      type={InputType.AUTOCOMPLETE}
      inputProps={{
        label: t('labelManufacturer'),
        placeholder: t('labelAll'),
        getOptions: manufacturerService.getMany,
        control,
      }}
    />
  );
};
